import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';

import { makeGetTask } from 'selectors/tasks';

import { updateTask } from 'actions/tasks';

import { useCanUser } from 'shared-hooks/permission';

import TaskName from 'components/task-name';
import TaskCompleteWrap from 'components/TaskCompleteWrap';
import SubtaskUtils from 'components/SubtaskUtils';
import MultiLineInput from 'components/MultiLineInput';

import IconClose from 'icons/icon-close';
import IconArrowLeft from 'icons/icon-arrow-left';
import IconMoreHoriz from 'icons/icon-more-horiz';

const SubtaskSingle = ({ id, name, createdBy, projectId, discussionElement, onClose, onDelete }) => {
    const { t } = useTranslation(['task']);
    const canEdit = useCanUser('editTask', [createdBy]);

    const handleCompleteToggle = useCallback(completed => {
        updateTask(id, { completed });
    }, [id]);

    const handleNameBlur = useCallback(name => {
        updateTask(id, { name });
    }, [id]);

    return (
        <div className="content-panel-main">
            <div className="content-panel-head">
                <div className="content-panel-subview-head">
                    <button className="content-panel-control btn content-panel-back" onClick={onClose}><IconArrowLeft size="20px" /></button>

                    <div className="content-panel-subview-head-main">
                        <TaskCompleteWrap
                            id={id}
                            dark={true}
                            size="large"
                            onChange={handleCompleteToggle}
                        />

                        <div className="content-panel-subview-title">
                            <MultiLineInput
                                className="content-panel-field-input"
                                placeholder={t('Add subtask name')}
                                canEdit={canEdit}
                                value={name}
                                onBlur={handleNameBlur}
                            />
                        </div>
                    </div>

                    <div className="content-panel-controls">
                        <div className="content-panel-simple-actions">
                            <div className="content-panel-control">
                                <SubtaskUtils
                                    id={id} 
                                    projectId={projectId}
                                    btnClassName="content-panel-actions-trigger"
                                    icon={<IconMoreHoriz size="16px" />}
                                    onDelete={onDelete}
                                >
                                    <span className="content-panel-actions-trigger"><i className="material-icons">more_horiz</i></span>
                                </SubtaskUtils>
                            </div>

                            <button className="content-panel-control btn content-panel-close" onClick={onClose}><IconClose /></button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content-panel-body">
                { discussionElement }
            </div>
        </div>
    );
}

const makeMapStateToProps = () => {
    const getTask = makeGetTask();

    return ({ tasks }, ownProps) => {
        const task = getTask(tasks.items, ownProps.id);
        return {
            name: task?.name,
            createdBy: task?.created_by
        }
    };
}

export default connect(makeMapStateToProps)(SubtaskSingle);
